var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapTypeRoadmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.394 18.916C.754 19.214 0 18.678 0 17.903v-14.9c0-.714.406-1.37.987-1.608L3.832.084c.639-.298 1.394.238 1.394 1.013v14.9c0 .714-.407 1.37-.987 1.608l-2.845 1.311zm8.825 0c.64.298 1.394-.238 1.394-1.013v-14.9c0-.714-.407-1.37-.987-1.608L7.78.084c-.64-.298-1.394.238-1.394 1.013v14.9c0 .714.407 1.37.987 1.608l2.845 1.311zm3.949 0c-.639.298-1.394-.238-1.394-1.013v-14.9c0-.714.407-1.37.987-1.608L16.606.084C17.246-.214 18 .322 18 1.097v14.9c0 .714-.406 1.37-.987 1.608l-2.845 1.311z",
    fill: "#051D39",
    fillRule: "evenodd"
  })));
}
export default SvgMapTypeRoadmap;